export enum Currency {
  CAD = 'CAD',
  USD = 'USD',
}

export enum Locale {
  enCA = 'en-CA',
  enUS = 'en-US',
}
